<template>
  <div class="fwd-index">
    <div class="list">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        :offset="50"
      >
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <div class="one_list" v-for="item in dongtai" :key="item.id" @click="getDetail(item.id)">
            <div class="box">
              <div class="box-left">
                <div class="left">
                  <img :src="item.titleUrl" alt="" />
                </div>
              </div>
              <div class="box_right">
                <div class="right">
                  <div class="right_top">
                    {{ item.title }}
                  </div>
                  <div class="right-botttom vottom">
                    <div style="display: flex; align-items: center">
                      <img src="../../assets/shu.png" alt="" />
                      <p>{{ item.pageview }}人阅读</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-pull-refresh>
      </van-list>
    </div>
  </div>
</template>

<script>
import { Donglist } from "../../api/user";
import { Toast } from "vant";
export default {
  data() {
    return {
      dongtai: [], //服务动态数据
      loading: false,
      finished: false,
      isLoading: false,
      dong: {
        status: 3,
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
    };
  },

  created() {
    this.getdong(); //服务动态;
  },

  methods: {
    onRefresh() {
      setTimeout(() => {
        Toast("刷新成功");
        this.isLoading = false;
        this.getdong();
      }, 1000);
    },
    // 异步更新数据
    // setTimeout 仅做示例，真实场景中一般为 ajax 请求
    //服务动态
    async getdong() {
      this.loading = true; //关闭无限滚动
      const res = await Donglist(this.dong);
      if (res.rows == null) {
        this.dongtai = [];
        this.finished = true;
      } else {
        this.total = res.total;
        this.dongtai.push(...res.rows);
        this.loading = false; // 加载状态结束
        this.dongtai.length >= this.total ? (this.finished = true) : "";
      }
    },
    onLoad() {
      this.getdong(this.dong); // 调用上面方法,请求数据
      this.dong.pageNum++; // 分页数加一
    },
    //去服务动态详情
    getDetail(id) {
      this.miniJump(`/detail/${id}?type=0`)
    },
  },
};
</script>

<style lang="scss" scoped>
.fwd-index {
  width: 100%;
  min-height: 100vh;
  background: #f5f5f5;
  padding: 10px 4%;
  .scroll {
    position: fixed;
    top: 5px;
  }

  .one_list {
    width: 100%;
    height: 100px;
    background: #fefffe;
    border-radius: 8px;
    margin-bottom: 10px;

    .box {
      width: 100%;
      height: 100%;
      display: flex;
      .box_right {
        width: 60%;
        height: 100%;
        .right {
          width: 100%;
          height: 100%;
          .vottom {
            display: flex;
            justify-content: space-between;
            padding: 10px;
            box-sizing: border-box;
          }
          .right-botttom {
            width: 100%;
            height: 40%;
            display: flex;
            align-items: center;
            padding: 8px;

            img {
              width: 12px;
              height: 12px;
            }
            p {
              color: #999999;
              font-size: 12px;
            }
          }
          .right_top {
            width: 100%;
            height: 50%;
            color: #323332;
            font-size: 14px;
            padding: 8px;
            box-sizing: border-box;
            font-family: PingFang SC-粗体, PingFang SC;
            font-weight: normal;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            align-content: center;
          }
        }
      }
      .box-left {
        width: 40%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        .left {
          width: 95%;
          height: 95%;
          img {
            width: 100%;
            height: 100%;
            border-radius: 8px;
          }
        }
      }
    }
  }
}
</style>